import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';
import FaceIcon from '@material-ui/icons/Face';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      display: 'flex',
      justifyContent: 'center',
      flexWrap: 'wrap',
      '& > *': {
        margin: theme.spacing(0.5),
      },
    },
  };
});

export default function SelectedOptions(props) {
  const classes = useStyles();
  const options = props.selectedUsers;
  console.log(options);
  const handleDelete = (index) => {
    props.deselectUser(index);
  };

  return (
    <div className={classes.root}>
      {options && options.map((item, index) => {
        return (
          <Chip
            key={item._id}
            icon={<FaceIcon />}
            label={item.name}
            color="primary"
            onDelete={() => { handleDelete(index); }}
          />
        );
      })}
    </div>
  );
}
